import {
  HiOutlinePaperAirplane,
  HiOutlineHandThumbUp,
  HiOutlineShieldCheck,
} from "react-icons/hi2";

const dataReasonInformation = [
  {
    id: "1",
    title: "Praktis",
    content: "Masuk website bisa di mana pun dan kapan pun",
    Icon: HiOutlinePaperAirplane,
  },
  {
    id: "2",
    title: "Terpercaya",
    content: "Permudah pengelolaan sampah Yang Anda Punya",
    Icon: HiOutlineHandThumbUp,
  },
  {
    id: "3",
    title: "Aman",
    content: "Transaksi dapat dilakukan sangat cepat dan mudah.",
    Icon: HiOutlineShieldCheck,
  },
];

export default dataReasonInformation;
